import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601, propExists } from '../../../../../../../../../../utils';
import { CustomerMembership } from '../../../../../../../../../../models/membership';

@Component({
  selector: 'app-edit-recurring-customer-membership-undo-scheduled-freeze',
  templateUrl: './edit-recurring-customer-membership-undo-scheduled-freeze.component.html',
  styleUrls: ['./edit-recurring-customer-membership-undo-scheduled-freeze.component.css']
})
export class EditRecurringCustomerMembershipUndoScheduledFreezeComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public propExists = propExists;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .undoScheduledMembershipFreeze(
        this.membership
      )
      .then(() => {
        if (propExists(this.membership.membership_freeze_date)) {
          this.savedCallback('Membership freeze successfully unscheduled.');
        } else {
          this.savedCallback('Membership unfreeze successfully unscheduled.');
        }
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          if (propExists(this.membership.membership_freeze_date)) {
            this.errorMessage = 'You do not have permission to unschedule this membership\'s freeze.';
          } else {
            this.errorMessage = 'You do not have permission to unschedule this membership\'s unfreeze.';
          }
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
